import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

interface Props {
  value?: string | number | null;
  placeholder?: string;
  label?: string | null;
  type?: string;
  error?: string | null;
  disabled?: boolean;
  rounded?: string;
}
interface Emits {
  (e: 'input', data: Props['value']): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiInput',
  props: {
    value: { default: null },
    placeholder: { default: undefined },
    label: { default: null },
    type: { default: 'text' },
    error: { default: null },
    disabled: { type: Boolean, default: false },
    rounded: { default: 'rounded-xl' }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', data: Props['value']): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string | number | null, placeholder: string, label: string | null, type: string, error: string | null, disabled: boolean, rounded: string };





const valueLocal = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const input = ref();

return { __sfc: true,props, emit, valueLocal, input }
}

})